import useAuthClaims from '../../../hooks/useAuthClaims'
import { useAppDispatch } from '../../../store'
import useLiveCallMonitorReadings from '../hooks/useLiveCallMonitorReadings'
import LiveCallMonitorButton from '../views/LiveCallMonitorButton'

const LiveCallMonitorButtonContainer = () => {
  const { claims } = useAuthClaims()
  const role = claims?.role

  const canView = !!role && ['hlo-admin', 'librarian'].includes(role)

  const { readings } = useLiveCallMonitorReadings({ skip: !canView })

  if (!canView) {
    return null
  }

  return <LiveCallMonitorButton numberOfLiveReadings={readings.length} />
}

export default LiveCallMonitorButtonContainer
